import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["subtotal", "grandTotal", "shipping", "shippingDisplay"]

    connect() {
        console.log("QuoteFormController connected");
        this.calculateTotals()
    }

    // Called when any pricing controller dispatches priceChanged event
    priceChanged() {
        this.calculateTotals()
    }

    // Called when shipping input changes
    shippingChanged() {
        this.calculateTotals()
    }

    calculateTotals() {
        // Sum all line totals from the DOM by reading the displayed values
        let subtotal = 0

        // Find all line total elements and sum their values
        const lineTotals = this.element.querySelectorAll("[data-quote-pricing-target='lineTotal']")
        lineTotals.forEach(el => {
            const text = el.textContent.trim()
            if (text.startsWith("$")) {
                subtotal += parseFloat(text.replace("$", "")) || 0
            }
        })

        // Get shipping value
        const shipping = this.hasShippingTarget ? (parseFloat(this.shippingTarget.value) || 0) : 0

        // Calculate grand total
        const grandTotal = subtotal + shipping

        // Update displays
        if (this.hasSubtotalTarget) {
            this.subtotalTarget.textContent = `$${subtotal.toFixed(2)}`
        }

        if (this.hasShippingDisplayTarget) {
            this.shippingDisplayTarget.textContent = `$${shipping.toFixed(2)}`
        }

        if (this.hasGrandTotalTarget) {
            this.grandTotalTarget.textContent = `$${grandTotal.toFixed(2)}`
        }
    }

    // Called when the main dimension unit selector changes
    updateDimensions(event) {
        console.log("updateDimensions called", event.target.value);
        const unit = event.target.value
        // Update the visual display for other dimension fields
        this.element.querySelectorAll('.dimension-unit-display').forEach(el => {
            el.textContent = unit
        })
    }
}
